var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -2048 2055 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1, -1)",
    d: "M0 1664v-1082q29 23 61 39.5t67 28.5v815l896 -449l896 449v-953h-1024v-128h1152v1280h-2048zM1024 1160l-753 376h1506zM549 512q-50 0 -110.5 2.5t-121.5 -0.5t-118 -14.5t-101.5 -40t-71 -77.5t-26.5 -126q0 -53 20.5 -99.5t55 -81t81.5 -55t99 -20.5v128 q-27 0 -50 10t-40.5 27.5t-27.5 40.5t-10 50t10 50t27.5 40.5t40.5 27.5t50 10h293l-162 -163l90 -90l317 317l-317 317l-90 -90z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailForward);
export default __webpack_public_path__ + "static/media/email-forward.086ec8f7.svg";
export { ForwardRef as ReactComponent };